module.exports = __webpack_public_path__ + "img/dcmm_15.5c2b1280.png";